//
// CachedReportURL.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "./CachedReportURLType";

var CachedReportURL = createModule("BIRD::CachedReportURL", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        contentKey: 7,
        name: 7,
        serverFile: 7,
        type: 4,
        content: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default CachedReportURL;
